export default {
    loading: false,
    loadingDetalhesProcesso: false,
    detalhesProcessoBacklog: null,
    macroprocessos: [],
    interrupcoes: {},
    items: [],
    itemsDesativacao: [],
    itemsMacroprocessoDesativacao: [],
    tarefas: [],
    headerBacklog: {
        estatisticas: [],
        estatisticasGerais: {}
    },
    filtrosPainelBacklog: null,
}